import React from "react";
import Box from "@mui/material/Box";
import { ChatMessage } from "./ChatMessage";
import CircularProgress from "@mui/material/CircularProgress";

interface Message {
  id: string;
  type: "user" | "assistant";
  content: string;
}

interface ChatContainerProps {
  messages: Message[];
  loading: boolean;
}

export function ChatContainer({ messages, loading }: ChatContainerProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        overflow: "auto",
        p: 2,
        flexGrow: 1
      }}
    >
      {messages.map((message) => (
        <Box key={message.id} sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
          <ChatMessage
            type={message.type}
            message={message.content}
            loading={loading && message.type === "user" && message.id === messages?.[messages.length - 1]?.id}
          />
        </Box>
      ))}
    </Box>
  );
}
